import React from 'react';

class HiredNotificationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Only log errors in development
    if (process.env.NODE_ENV === 'development') {
      console.error('HiredNotification Error Boundary caught an error:', error, errorInfo);
    }
    
    // In production, you might want to log this to an error reporting service
    // reportError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fail silently in production - don't show any error UI for notifications
      if (process.env.NODE_ENV === 'development') {
        return (
          <div className="fixed top-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded z-50">
            <strong>Notification Error:</strong> Something went wrong with the hired notification system.
          </div>
        );
      }
      // In production, render nothing - fail silently
      return null;
    }

    return this.props.children;
  }
}

export default HiredNotificationErrorBoundary;